export class NotaCuentaDTO{
  id: string;
  nota:string;
}
